module.exports = __webpack_public_path__ + "img/product_card.0f5dd492.png";